import { API_ENDPOINTS } from "@/constants/api";
import type { PlanQuotaKey } from "@/constants/quotas";

/** Missing/null means Unlimited. Zero disables a monthly API; zero capacity remains an explicit allowance. */
export type PlanLimits = Partial<Record<PlanQuotaKey, number | null>>;

export interface Plan {
  id: string;
  name: string;
  description: string | null;
  price: number;
  currency: string;
  billingInterval: string;
  trialDays: number;
  features: string[];
  limits: PlanLimits;
}

export async function listPublicPlans(): Promise<Plan[]> {
  const res = await fetch(API_ENDPOINTS.PLANS.LIST, { credentials: "include" });
  if (!res.ok) throw new Error(`Failed to fetch plans: ${res.status}`);
  return res.json();
}

export async function subscribeToPlan(planId: string): Promise<{ setupUrl: string | null }> {
  const res = await fetch(API_ENDPOINTS.SUBSCRIPTION.CREATE, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ planId }),
  });
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(body || `Failed to subscribe: ${res.status}`);
  }
  return res.json();
}
